import { useContext } from "react";
import { ethers } from "ethers";
import React, { useState, useEffect } from "react";
import "../styles/Mint.css";
import contractArtifact from "../contracts/PromptMeister.json";
import { EthereumContext } from "./Layout";

function Mint() {
  let { userAccount, walletProvider, signer, contract } =
    useContext(EthereumContext);
  const [mp, setMP] = useState(null);
  useEffect(() => {
    if (contract) {
      getMintPrice();
    }
  }, [contract]);
  async function getMintPrice() {
    try {
      let mintPrice = await contract.getMintPrice();
      let mintPriceInMatic = ethers.formatEther(mintPrice);
      mintPriceInMatic = (
        Math.ceil(parseFloat(mintPriceInMatic) * 1000) / 1000
      ).toString();
      setMP(mintPriceInMatic.toString());
    } catch (error) {
      console.error("Failed to get mint price:", error);
      // Handle the error appropriately in your application
    }
  }

  async function mintToken() {
    if (!userAccount) {
      alert("Please connect your wallet");
      return;
    }
    let quantity = parseInt(document.getElementById("prompt-input").value);
    console.log(quantity);
    if (isNaN(quantity) || quantity <= 0) {
      alert("Please enter a valid quantity");
      return;
    }
    let totalPriceInMatic = (mp * quantity).toString();
    try {
      const overrides = {
        value: ethers.parseEther(totalPriceInMatic),
      };
      console.log(userAccount);
      const tx = await contract.safeMint(userAccount, quantity, overrides);
      await tx.wait();
      console.log("NFT minted successfully!");
    } catch (error) {
      console.error("Error minting NFT: ", error);
    }
  }
  function handleKeyDown(event) {
    if (event.key == "Enter") mintToken();
  }
  return (
    <div className="container-mint">
      <div className="mint one">
        <h2>PRICE: {mp} MATIC + GAS</h2>
        <input
          type="text"
          id="prompt-input"
          placeholder="ENTER QUANTITY"
          min="1"
          max="1000"
          onKeyDown={handleKeyDown}
        />
        <button id="quantity-button" onClick={mintToken}>
          ENTER
        </button>
      </div>
    </div>
  );
}
export default Mint;
